import { Avatar as AntdAvatar, theme } from "antd";

import type { AvE2EProps } from "../types";
import type { AvatarProps as AntdAvatarProps } from "antd/lib";

type AvatarProps = AvE2EProps & AntdAvatarProps & { title?: string };

export function CustomAvatar(props: AvatarProps) {
  const { testIdPrefix, size, style, ...restProps } = props;
  const { token } = theme.useToken();

  // Note: Ant Design's Avatar textFontSize* tokens don't apply automatically, so we manually set fontSize in style
  const getFontSize = () => {
    if (typeof size === "number") {
      // For custom numeric sizes, scale proportionally (roughly 40% of container size)
      return size * 0.4;
    }

    switch (size) {
      case "large":
        return token.Avatar?.textFontSizeLG;
      case "small":
        return token.Avatar?.textFontSizeSM;
      default:
        return token.Avatar?.textFontSize;
    }
  };

  return (
    <AntdAvatar
      data-testid={`${testIdPrefix}-avatar`}
      size={size}
      style={{ fontSize: getFontSize(), ...style }}
      {...restProps}
    />
  );
}

export const Avatar = Object.assign(CustomAvatar, {
  Group: AntdAvatar.Group,
});
